module.exports = __webpack_public_path__ + "static/InfectedPersonsPrefecture_16.dot-d6f12d424fbc45964a8560bbf79af195.svg";